import { render, staticRenderFns } from "./RepCursosNal.vue?vue&type=template&id=c58d4a6a&"
import script from "./RepCursosNal.vue?vue&type=script&lang=js&"
export * from "./RepCursosNal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports